import classNames from 'classnames';
import NioBrand from '../../../NioBrand/NioBrand';

export default function HeaderLogo({ className, isDark = false }) {
  const compClasses = classNames({
    "nk-header-logo": true,
    [`${className}`]: className
  });

  return (
    <NioBrand
      logo="s1"
      variant={isDark ? 'light' : 'dark'}
      className={compClasses}
    />
  );
}
